/**
 * Format health numbers: drop trailing ".0" (100.0 → 100) but keep real decimals (98.6).
 */
export function formatHealthNumberSmart(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const rounded = Math.round(value * 10) / 10;
  if (Number.isInteger(rounded) || Math.abs(rounded - Math.round(rounded)) < 1e-6) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(1);
}

/** Stress / strain scores as whole-number percentages */
export function formatHealthPercentScore(value: number): string {
  if (!Number.isFinite(value)) return "—";
  const v = Math.round(Math.max(0, Math.min(100, value)));
  return `${v}%`;
}
